import * as yup from 'yup';
import { isDomainValid } from 'utils/validatorUtils';

const PERSON_NAME_REGEX = /[^a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]/i;

const PERSON_TITLE_REGEX = /^[a-zA-Z&\-\s]+$/i;

const EMAIL_REGEX = /^[A-Za-z0-9'._%+-]{1,64}@[A-Za-z0-9.-]+\.[a-z]{2,255}$/i;

export const stringValidation = (yupInstance: typeof yup) => {
  yupInstance.addMethod(yup.string, 'domain', function (message: string) {
    return this.test('domain', message, function (value) {
      const { path, createError } = this;
      if (!value) return true;

      const isValid = isDomainValid(value);
      if (isValid) return true;
      return createError({ path, message });
    });
  });

  yupInstance.addMethod(yup.string, 'personName', function (message: string) {
    return this.test('personName', message, function (value) {
      const { path, createError } = this;
      if (!value) return true;

      const isValid = !PERSON_NAME_REGEX.test(value);
      if (isValid) return true;
      return createError({ path, message });
    });
  });

  yupInstance.addMethod(yup.string, 'personTitle', function (message: string) {
    return this.test('personTitle', message, function (value) {
      const { path, createError } = this;
      if (!value) return true;

      const isValid = PERSON_TITLE_REGEX.test(value);
      if (isValid) return true;
      return createError({ path, message });
    });
  });

  yupInstance.addMethod(yup.string, 'email', function (message: string) {
    return this.test('email', message, function (value) {
      const { path, createError } = this;
      if (!value) return true;

      const isValid = EMAIL_REGEX.test(value);
      if (isValid) return true;
      return createError({ path, message });
    });
  });
};
